module.exports = __webpack_public_path__ + "static/media/Logo_Animation1.c7d2c06f.gif";